import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { useEquipmentHistory } from "@/hooks/use-equipment";
import { eventDetail, eventLabel } from "@/lib/event-registry";
import { formatDate } from "@/lib/format";

/** Historikk fra event_log: registrering, import, endringer, forsikring og bilder. */
export function EquipmentHistory({ equipmentId }: { equipmentId: string }) {
  const { data: entries = [], isLoading } = useEquipmentHistory(equipmentId);
  return (
    <Card>
      <CardHeader className="pb-2">
        <CardTitle className="text-base">Historikk</CardTitle>
      </CardHeader>
      <CardContent>
        {isLoading ? (
          <p className="text-sm text-muted-foreground">Laster …</p>
        ) : entries.length === 0 ? (
          <p className="text-sm text-muted-foreground">Ingen hendelser ennå.</p>
        ) : (
          <ul className="divide-y text-sm">
            {entries.map((e) => {
              const detail = eventDetail(e.event_type, e.payload);
              return (
                <li key={e.id} className="flex flex-wrap items-baseline justify-between gap-2 py-2">
                  <span>
                    {eventLabel(e.event_type)}
                    {detail && <span className="text-muted-foreground"> · {detail}</span>}
                  </span>
                  <span className="text-xs text-muted-foreground">
                    {e.users?.full_name ?? "System"} · {formatDate(e.created_at)}
                  </span>
                </li>
              );
            })}
          </ul>
        )}
      </CardContent>
    </Card>
  );
}
